import faviconSvg from "assets/favicon.svg";
import { useEffect } from "react";

const useFavicon = (link: string | undefined) => {
  return useEffect(() => {
    const favicon = document.getElementById("favicon");

    if (favicon instanceof HTMLLinkElement) {
      favicon.href = link ?? faviconSvg;
    }
  }, [link]);
};

export default useFavicon;
